// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const regidrago: PokeData = {
  "id": 895,
  "name": "regidrago",
  "height": 21,
  "weight": 2000,
  "base_experience": 290,
  "types": [
    PokeType.DRAGON
  ],
  "api_moves": [
    "vice-grip",
    "thrash",
    "bite",
    "hyper-beam",
    "focus-energy",
    "explosion",
    "dragon-breath",
    "twister",
    "crunch",
    "ancient-power",
    "dragon-claw",
    "dragon-dance",
    "hammer-arm",
    "laser-focus",
    "dragon-energy"
  ],
  "moves": [
    "bite",
    "dragon-breath",
    "crunch",
    "ancient-power",
    "dragon-claw",
    "dragon-dance",
    "dragon-fang",
    "great-roar",
    "inner-spirit",
    "dragon-vortex",
    "dragon-pulse",
    "draco-meteor",
    "scale-shot"
  ],
  "evolution_chain": {
    "id": 473,
    "item": null,
    "species": [
      {
        "name": "regidrago",
        "order": 895,
        "types": [
          PokeType.DRAGON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 164,
    "speed": 105,
    "ability_power": 131
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
